<template>
  <b-row>
    <b-col xl="12">
      <b-table responsive
          class="registro-ordenes"
          :items="cuentasInfo" 
          :fields="cuentasDetallesFields">
        <template v-slot:cell(montoBase)="data">
          {{ data.item.montoBase | numero(2, true) }}
        </template>            
        <template v-slot:cell(montoImpuestos)="data">
          {{ data.item.montoImpuestos | numero(2, true) }}
        </template>

        <template v-slot:cell(opciones)="data" >
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item @click.stop="editarCuenta(data.item)">
              <i class="fa fa-edit"></i>Editar Cuenta</b-dropdown-item>
            <b-dropdown-item @click.stop="borrarCuenta(data.item)">
              <i class="fa fa-remove"></i>Borrar Cuenta</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="agregarCuenta">Agregar Cuenta</b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      cuentasDetallesFields: [
        { 
          key: 'codigoCuenta',
          label: 'Codigo' 

        },
        { key: 'cuenta' },
        { 
          key: 'montoBase',
          class: 'text-right' 
        },
        { 
          key: 'montoImpuestos',
          class: 'text-right' 
        },
        { 
          key: 'opciones',
          label: '',
          class: "text-center"
        },
      ],
    }
  },
  created() {
  },  
  methods: {
    agregarCuenta() {
      this.$emit('agregarCuenta')
    },
    editarCuenta(item) {
      this.$emit('editarCuenta', item)
    },
    borrarCuenta(item) {
      this.$emit('borrarCuenta', item)
    },
  },
  computed: {
    cuentasInfo: function () {
      return this.$store.getters['compra/getCuentasInfo']
    },
  },

}
</script>

<style>
</style>